export type SimulatedRepaymentSchedule = {
    loanAmount: number;
    totalInterestToPay: number;
    effectiveTotalInterest: number;
    effectiveInterest: number;
    processingFee: number;
    managementFee: number;
    insuranceFee: number;
    tenureUnit: string;
    repaymentFrequency: number;
    scheduleList: SimulatedRepaymentScheduleBreakdown[];
}

export type SimulatedRepaymentScheduleBreakdown = {
    principal: number;
    interest: number;
    principalRepayment: number;
    totalRepayment: number;
}

export enum EligibleAmountCreationSource {
    MGR_LOOKUP = "MGR_LOOKUP",
    GLOBAL_LOOKUP = "GLOBAL_LOOKUP"
}

export type Tenure = {
    tenure: string;
    tenureUnit: string;
}

export type LabeledTenure = {
    tenure: string;
    tenureUnit: string;
    label: string;
    value: string;
}
